export default {
  //baseURL: 'http://localhost:51946'
  baseURL: 'https://hml.api1nas.com.br/Vendas'
  //baseURL: 'https://prd.api1nas.com.br/Vendas' //PRODUÇÃO
}